import React from 'react';
import ReactDOM from 'react-dom/client';
// Base design system AVANT les pages : garantit que le CSS page-local
// (chargé via App) override la base, pas l'inverse (anti-régression migration).
import './index.css';
import './App.css';
import App from './App';
import { applyTheme, getTheme } from './utils/theme';

// Applique le thème AVANT le rendu (évite le flash).
applyTheme(getTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
